
import React from 'react';

interface GraphHeaderProps {
  totalCompletedRoutines: number;
  progressPercentage: number;
}

export const GraphHeader = ({ totalCompletedRoutines, progressPercentage }: GraphHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
        <h3 className="hidden sm:block text-4xl font-bold font-heading text-primary">
          {totalCompletedRoutines}
        </h3>
        <div className="hidden sm:flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-4 h-0.5 bg-clubbers-light-blue"></div>
            <span className="text-sm text-primary/60">RUTINAS COMPLETADAS</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-0.5 border-t border-dashed border-primary/20"></div>
            <span className="text-sm text-primary/60">META DIARIA</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start sm:items-end">
        <h3 className="text-4xl font-bold font-heading text-primary">
          {progressPercentage}%
        </h3>
        <p className="text-xs text-primary/60 leading-tight sm:text-right">
          PROGRESO<br />SEMANAL
        </p>
      </div>
    </div>
  );
};
